/**
 * mockCRM — CRMPort adapter that simulates a connected CRM in memory.
 *
 * Used as V0.01 default so the app can demo end-to-end flows (sync,
 * push outcome, subscribe to signals) without any real credential.
 *
 * Real CRM adapters (ghl.js, hubspot.js, salesforce.js) share the exact
 * same surface.
 */
export function createMockCRM() {
  const listeners = new Set();
  const pushedOutcomes = [];
  return {
    async status() {
      return { status: "connected", vendor: "mock" };
    },
    async connect() {
      return { ok: true, message: "Mock CRM connected" };
    },
    async disconnect() { /* no-op */ },
    async syncActors() { return []; },
    async syncSignals() { return []; },
    async pushOutcome(outcome) {
      pushedOutcomes.push(outcome);
      return { ok: true };
    },
    async pushActorUpdate() { return { ok: true }; },
    subscribeToSignals(cb) {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    async resolveContact() {
      return { status: "not_found", contactId: null, candidates: [] };
    },
    // Test helper — allows demoing a signal push
    __simulateSignal(signal) {
      listeners.forEach((cb) => cb(signal));
    },
    __pushedOutcomes() { return pushedOutcomes.slice(); },
  };
}
